/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicUserProfile } from '../models/PublicUserProfile';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UsersService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get public profiles for a list of user IDs
     * @param ids Comma-separated list of user IDs (max 50)
     * @returns PublicUserProfile
     * @throws ApiError
     */
    public getPublicUserProfiles(
        ids: string,
    ): CancelablePromise<Array<PublicUserProfile>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/profiles',
            query: {
                'ids': ids,
            },
        });
    }
}
